// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"75fca00c","513":"a6d2784b"}[chunkId] + ".chunk.js";
};